<!-- <mat-sidenav-container id="oliverTemplate" [class.shoMyDelvery]="enableRSMenu" *ngIf="(Menus['sortedLinks']?.length > 0 && featureTags['category_menu_auto_generate'] && this.screenWidth >= 800) || !featureTags['category_menu_auto_generate'] || this.screenWidth <= 800"> -->

    <mat-sidenav [opened]="false" mode="over" #sidenav class="sidenav mat-elevation-z6 mt-55">
        <div [ngStyle]=" {'background':settings.theme}" class="pt-8 sideDiv">
            <button mat-icon-button color="warn" class="close bg-wht" (click)="sidenav.close()">
                <i class="material-icons warn" data-icon="close"></i>
            </button>
            <div>
                <img *ngIf="!loggedIn" class="profile" alt="Profile"
                src="assets/images/default-avatar.png">
                <div class="avatar" *ngIf="loggedIn">
                    {{userDetails['first_name'] | slice: 0: 1 | titlecase}}{{userDetails['last_name'] | slice: 0: 1 |
                    titlecase}}
                </div>
                <h5 *ngIf="loggedIn" class="name">{{userDetails['first_name']}} {{userDetails['last_name']}}</h5>
            </div>
        </div>
        <div class="mob-search">
            <form [formGroup]="searchForm" class="search-form" fxLayout="row">
                <input type="text" placeholder="Type to search..." fxFlex
                    (keydown.enter)="mobileSearch(searchForm.value)" formControlName="keyword">
                <button mat-mini-fab (click)="mobileSearch(searchForm.value)" matTooltip="search products" type="button"
                    class="search-btn mat-elevation-z0 text-muted">
                    <i class="material-icons" data-icon="search"></i>
                </button>
            </form>
        </div>     
      <div *ngIf="MenusHeight['sortedHeight']">
          <app-sidenav-menu *ngFor="let sideNav of MenusHeight['sortedHeight']" [menuItems]="sideNav" [menuParentId]="0"
          (emitPass)="handleChange($event)">
          </app-sidenav-menu>         
            <div *ngFor = "let menuItem of sidenavMenuItems['desktop_links']">
                <div  *ngIf = "menuItem['title']['display']">
                    <a  mat-button  *ngIf = "menuItem['title']['display']['desktop'] === true"
                    fxLayout="row" fxLayoutAlign="start center"
                    routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"        
                    (click)="handleChange(menuItem)" 
                    [ngClass]="!!menuItem['title']['cssClass'] ? menuItem['title']['cssClass'] : ''">
                        <span *ngIf = "menuItem['title']['type'] === 'public'" class="text-uppercase menu-title1" [innerHTML]="menuItem['title']['name'] | sanitizeHtml ">check1</span>
                        <span *ngIf = "menuItem['title']['type'] === 'private' && loggedIn" class="text-uppercase menu-title1"  [innerHTML]="menuItem['title']['name'] | sanitizeHtml ">check2</span>   
                    </a>
                    <div class="menu-item" *ngFor="let subLinks of menuItem['links']"
                        [class.active]="router.url === '/'+subLinks.href">
                        <a  mat-button  *ngIf="subLinks['display'] && subLinks['display']['desktop'] === true"
                        fxLayout="row" fxLayoutAlign="start center" class="pl-0"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:true}"        
                        (click)="handleChange(subLinks)" >
                            <mat-icon  class="mat-icon-sm pad-right pl-18" *ngIf = "subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] !== 'sign-in'">{{subLinks['icon']}}</mat-icon>
                            <span *ngIf = "subLinks['type'] === 'public'  && subLinks['href'] !== 'sign-in' " class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml"></span>
                            <mat-icon class="mat-icon-sm pad-right pl-18" *ngIf = "subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn">{{subLinks['icon']}}</mat-icon>
                            <span *ngIf = "subLinks['type'] === 'public' && subLinks['href'] === 'sign-in' && !loggedIn" class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                            <mat-icon class="mat-icon-sm pad-right pl-18" *ngIf = "subLinks['icon'] !== null && subLinks['iconType'] === 'material' && subLinks['type'] === 'private' && loggedIn">{{subLinks['icon']}}</mat-icon>
                            <span *ngIf = "subLinks['type'] === 'private' && loggedIn" class="pl-5 text-uppercase" [innerHTML]="subLinks['name'] | sanitizeHtml "></span>
                        </a>
                    </div>      
                </div>
             </div>
           <div class="menu-item">
            <a mat-button fxLayout="row" fxLayoutAlign="start center" class="pl-0  bo-5 " [routerLink]="['/contact']">           
                <span  >CONTACT US</span>
                </a>
           </div>          
      </div>   

        <div class="divider"></div>
        <div class="text-center py-2 socialIconsSN" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
            <a *ngFor="let SI of storeDetailsJson['socialMedia']" [href]="SI.href" target="_blank">
                <i [class]="'fa fa-'+SI.icon"></i>
            </a>
        </div>
    </mat-sidenav>
<div id="oliverTemplate">
    
    <mat-toolbar class="ThemeHeader" id="title">
        <div class="searchProducts" *ngIf="isShowSearch">
            <div class="wd-50" fxShow="false" fxShow.gt-sm>
               
                <app-search-products 
                    #searchProductsInDesktopView
                    [store]="storeDetails"
                    [user]="userDetails"
                    [showSearchResult]="showSearchProductsResult"></app-search-products>
            </div>
        </div>
        <mat-toolbar-row class="headerLogo" fxShow.gt-sm>
            <div class="containerLg" fxLayout.xs="column" fxLayoutGap.xs="20px" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                    <a *ngIf="storeDetailsJson['header'] && storeDetailsJson['header']['logoImage'] === ''" class="logo"
                        routerLink="/index" (click)="closeSubMenus()">
                        {{storeDetailsJson['header']['logoText']}}
                    </a>
                    <a fxLayout="row" fxLayoutAlign.xs="center center"
                        *ngIf="storeDetailsJson['header'] && storeDetailsJson['header']['logoImage'] !== ''"
                        (click)="closeSubMenus()" routerLink="/index">
                        <img [src]="storeDetailsJson['header']['logoImage']" class="brandLogo" [alt]="storeDetailsJson['header']['logoText']"
                            [ngStyle]="{'background': storeDetailsJson['settings']['imageBackground']}" />
                    </a>
                </div>
                <div fxHide fxShow.gt-md>
                    <ul class="list-inline navMenu" fxLayout="row">
                        <li *ngFor="let link of sidenavMenuItems['main_menu']">
                          <!-- Link without submenu -->
                           <ng-container *ngIf="!link.title.submenu">
                               <a *ngIf="link.title.name !== 'Gift Card'" [routerLink]="link.title.href">
                                 {{link.title.name}}
                               </a>
                               <a *ngIf="link.title.name === 'Gift Card'" [href]="link.title.href" 
                               target="_blank" 
                               rel="noopener noreferrer">
                                 {{link.title.name}}
                               </a>
                           </ng-container>
                          
                          <!-- Link with submenu -->
                          <ng-container *ngIf="link.title.submenu">
                            <a *ngIf="link.title.name == 'Info'"
                             [matMenuTriggerFor]="menuInfo" [routerLink]="link.title.href">
                              {{link.title.name}}
                            </a>
                            <mat-menu #menuInfo="matMenu" class="mainMenu">
                                <ng-container *ngFor="let submenu of link.title.submenu">
                                  <a mat-menu-item [routerLink]="submenu.href" class="info-dropdown">
                                    {{submenu.name}}
                                  </a>
                                </ng-container>
                              </mat-menu>
                            <a *ngIf="link.title.name == 'More'"
                              [matMenuTriggerFor]="menuMore" [routerLink]="link.title.href">
                                {{link.title.name}}
                              </a>
                            <mat-menu #menuMore="matMenu" class="mainMenu">
                              <ng-container *ngFor="let submenu of link.title.submenu">
                                <a mat-menu-item [routerLink]="submenu.href" class="info-dropdown">
                                  {{submenu.name}}
                                </a>
                              </ng-container>
                            </mat-menu>
                          </ng-container>
                        </li>
                      </ul>
                </div>
                <div>
                    <ul class="list-inline userAccout" fxLayout="row" fxLayoutGap="15px">
                        <li class="order-now">
                            <a routerLink="/shop">Order now</a>
                        </li>
                        <li (click)="SearchProductsFn()" class="hand-hover">
                            <i class="fa fa-search"></i>
                        </li>
                        <li style="margin: 0 !important;" *ngIf="!loggedIn">
                                <a routerLink="/sign-in"><i class="fa fa-user"></i></a>
                        </li>
                        <li style="margin: 0 !important;" *ngIf="loggedIn">
                            <app-top-menu *ngIf="sidenavMenuItems['desktop_links']"
                                [menuItems]="sidenavMenuItems['desktop_links']" [menuParentId]="0"
                                (emitPass)="handleChange($event)" fxShow.gt-sm></app-top-menu>
                        </li>
                        <li class="cart-li" style="margin: 0 !important;">
                            <!-- <div (click)="enableRMenu()">
                                <a routerLink="/cart"><i class="fa fa-shopping-cart"></i></a>
                            </div> -->
                            <div class="cart-action cartBtm" id="cart-link" (click)="enableRMenu()">
                                <a routerLink="/edit-order">
                                    <i class="fa fa-shopping-cart"></i>
                                    <sup class="initials1 cartcount">0</sup> 
                                </a>
                            </div>
                        </li>
                        <li>
                            <span fxShow="false" fxShow.lt-md class="btnNavIcon">
                                <button mat-button (click)="sidenav.toggle()" class="sidenav-toggle menuBtn">
                                    <i class="material-icons md-36" data-icon="menu"></i>
                                </button>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </mat-toolbar-row>
    </mat-toolbar>

    <div class="theme-container" ngStyle.lt-md="margin: 0;" [class.fullW]="isCmsView" (click)="onClickSearch()" *ngIf="router.url != '/index' && router.url != '/index' && router.url != '/index#contact-us'">
        <!-- Delivery Calendar -->
        <!-- <div class="full-width-calendar">
            <app-delivery-calendar *ngIf="loggedIn"></app-delivery-calendar>
        </div> -->
        <!-- [class.fullWidth]="isCmsView" -->
        <!-- <app-breadcrumb *ngIf="!isMobile"  [categories]="categories" [vendors] = "vendors"></app-breadcrumb> -->
        <div fxLayout="row wrap" *ngIf="router.url != '/' && !isMobile &&  router.url !== '/cart' && router.url != '/membership-purchase'">
            <div fxFlex="100" *ngIf="!isCmsView">
                <mat-card fxLayout="row" class="breadcrumb light-block">
                    <a *ngIf="router.url != '/'" routerLink="/shop" class="breadcrumb-item" fxLayout="row"
                        fxLayoutAlign="start center" (click)="closeSubMenus('category')">
                        <i class="material-icons homeicon" data-icon="home"></i>
                        <span class="breadcrumb-title">Homepage</span>
                    </a>
                    <div *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item" fxLayout="row"
                        fxLayoutAlign="start center">
                        <a [hidden]="i == (breadcrumbs.length - 1)"
                            [routerLink]="[breadcrumb.url]">{{breadcrumb.name}}</a>
                        <span [hidden]="i != (breadcrumbs.length - 1)"
                            class="breadcrumb-title active"><b>{{breadcrumb.name}}</b></span>
                    </div>
                </mat-card>
            </div>
        </div>
        <!-- <router-outlet></router-outlet> -->
    </div>

    <!-- <app-footer></app-footer> -->
<!-- </mat-sidenav-container> -->
</div>

